import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: 'e8fcb3d1-ec3d-422a-a55b-14f5295e04e1',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '952e9e9e-8b52-4d8b-ad30-67095fc673c8',
      type: 'Sprite',
      name: 'baseImage',
      nameSpace: '',
      className: '',
      x: 2,
      y: -30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: 'e8fcb3d1-ec3d-422a-a55b-14f5295e04e1',
      data: ''
    },
    {
      id: '6664c3e0-7c8f-449e-8afc-a959cd80de78',
      type: 'Sprite',
      name: 'shareFrame',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shareframe',
      parent: 'e8fcb3d1-ec3d-422a-a55b-14f5295e04e1',
      data: ''
    },
    {
      id: '136deffc-895a-4091-af7d-2c62e82ea42c',
      type: 'Sprite',
      name: 'shareButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 312,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_blue',
      parent: 'e8fcb3d1-ec3d-422a-a55b-14f5295e04e1',
      data: ''
    },
    {
      id: '342031bd-10f3-4ef0-8465-77022cec2b02',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 465,
      y: -311,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'btn_close',
      parent: 'e8fcb3d1-ec3d-422a-a55b-14f5295e04e1',
      data: ''
    },
    {
      id: '85d2832a-0a32-48e7-b31e-fb8cca46565a',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Share',
      localize: true,
      maxWidth: 210,
      maxHeight: 75,
      maxFontSize: 50,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#00000059',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '136deffc-895a-4091-af7d-2c62e82ea42c',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class FarmSharePopupLayout {
  static raw = raw;
  root: PIXI.Container
  baseImage: PIXI.Sprite
  shareFrame: PIXI.Sprite
  shareButton: PIXI.Sprite
  closeButton: PIXI.Sprite

  constructor() {
    populate(this, raw);
  }
}
